import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4cf8280f&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4cf8280f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8280f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf8280f')) {
      api.createRecord('4cf8280f', component.options)
    } else {
      api.reload('4cf8280f', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=4cf8280f&scoped=true&", function () {
      api.rerender('4cf8280f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/Logo.vue"
export default component.exports